import { render, staticRenderFns } from "./attention_heatmap.vue?vue&type=template&id=d2312ba8&scoped=true&lang=pug&"
import script from "./attention_heatmap.vue?vue&type=script&lang=js&"
export * from "./attention_heatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2312ba8",
  null
  
)

export default component.exports